export default __webpack_public_path__ + "static/media/mahanandi.cb579210.png";